<div>
    <!-- Modal 
    <div class="modal fade show" id="disableProject" tabindex="-1" role="dialog" >
        <div class="modal-dialog modal-dialog-centered" role="document">-->
          <div class="modal-content">
            <div class="modal-header">
              <ng-container *ngIf="setActiveStateProject.isactive == true">
                <h5 class="modal-title" id="exampleModalLongTitle">{{ 'projectvisibilitytoggle.disableproject' | trans }}</h5>
              </ng-container>
              <ng-container *ngIf="setActiveStateProject.isactive == false">
                <h5 class="modal-title" id="enableproject">{{ 'projectvisibilitytoggle.enableproject' | trans }}</h5>
              </ng-container>
              <button #closeDisablemodal type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span >&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <ng-container *ngIf="setActiveStateProject.isactive == true">
                <p style="text-align: center;">{{ 'projectvisibilitytoggle.disabletip' | trans }}</p>
                <div class="alert alert-secondary f-13" role="alert">
                  {{ 'projectvisibilitytoggle.disablealert' | trans }} 
                </div>
              </ng-container>
              <ng-container *ngIf="setActiveStateProject.isactive == false">
                <p style="text-align: center;">{{ 'projectvisibilitytoggle.enabletip' | trans }}</p>
                <div class="alert alert-secondary f-13" role="alert">
                  {{ 'projectvisibilitytoggle.enablealert' | trans }}  
                </div>
              </ng-container>
              <ng-container *ngIf="successdisable">
                <div class="alert alert-success f-13" role="alert">
                  {{ 'projectvisibilitytoggle.successdisable' | trans }}  
                </div>
              </ng-container>
              <ng-container *ngIf="successenable">
                <div class="alert alert-success f-13" role="alert">
                  {{ 'projectvisibilitytoggle.successenable' | trans }}  
                </div>
              </ng-container>

              <div class="row" style="padding-top:10px;" >
                <div class="col">
                  <button type="button" data-dismiss="modal" class="btn-close"><h6 class="btn-save-text">{{ 'projectvisibilitytoggle.cancel' | trans }}</h6></button>
                </div>
                <div class="col" *ngIf="setActiveStateProject.isactive == true">
                  <button  (click)="disableProject()" type="button" data-dismiss="modal" class="btn-save"><h6 class="btn-save-text">{{ 'projectvisibilitytoggle.disableproject' | trans }}</h6></button>
                </div>
                <div class="col" *ngIf="setActiveStateProject.isactive == false">
                  <button  (click)="activateProject()" type="button"  data-dismiss="modal" class="btn-save"><h6 class="btn-save-text">{{ 'projectvisibilitytoggle.enableproject' | trans }}</h6></button>
                </div>
              </div>
            </div>
      
          </div>
        </div>
      <!-- </div>
</div> -->
